/* eslint-disable react-hooks/rules-of-hooks */

import { useRouter } from 'next/router';
import React, { useContext, useEffect } from 'react';
import { useUTMParameters } from '@pwskills/rachnaui/hooks';
import useInitLogin from '@/hooks/useInitLogin';
import Loader from '@/components/common/Loader';
import { dataLayer } from '@/utils/common/dataLayer.utils';
import ElevateYourCareerSection from '@/components/OnlineDegreePremiumDescriptionPage/ElevateYourCareerSection';
import PremiumInstituteNavBar from '@/components/OnlineDegreePremiumDescriptionPage/PremiumInstituteNavbar';
import { getPriceDetails } from '@/utils/helper/helperFunction';
import CourseDescriptionContext from '@/context/CourseDescriptionContext';
import useUserDetails from '../../../store/userDetails';

type Props = {
  children: React.ReactNode;
};

// OnlineDegreePremiumLayout page
const OnlineDegreePremiumLayout = ({ children }: Props) => {
  // const { user, isLoggedIn } = useContext(UserDetailsContext);
  const { userDetails: user, userIsLoggedIn: isLoggedIn } = useUserDetails();
  const { isLoading } = useInitLogin();
  const { courseDetails } = useContext(CourseDescriptionContext);

  const router = useRouter();

  const userDataLayerEvent = () => {
    const utmQuery = useUTMParameters();
    const userDataLayerObject = {
      event: 'user_details',
      user_type: isLoggedIn ? 'logged_in' : 'guest',
      user_name: isLoggedIn ? `${user.firstName} ${user.lastName || ''}` : null,
      email: isLoggedIn ? user.email : null,
      number: isLoggedIn ? `${user.isdCode}${user.phoneNumber || ''}` : null,
      country:
        (typeof window !== 'undefined' && window.localStorage.getItem('USER_COUNTRY')) || null,
      user_category: null,
      user_id: isLoggedIn ? user.id : null,
      gclid: null,
      utm_source: null,
      utm_medium: null,
      utm_campaign: null,
      ...utmQuery,
    };
    dataLayer(userDataLayerObject);
  };

  const DataLayerParam = () => {
    const {
      _id,
      title,
      classTimings,
      categoryIncludingParents,
      pricing,
      courseMetaDetails,
      ratingAverage,
      programType,
      ratingCount,
    } = courseDetails || {};
    const priceDetails = getPriceDetails(pricing);
    const DataLayerDegreePage = {
      course_id: _id,
      course_name: title,
      course_type: 'online_degree',
      source_page: 'online_degree_page',
      program_type: programType || null,
      domain: (categoryIncludingParents && categoryIncludingParents[0]?.title) || null,
      language: courseMetaDetails?.overview?.language || null,
      amount: priceDetails?.currentPrice || null,
      discountPercent: priceDetails?.discount || null,
      start_on: classTimings?.startDate || null,
      duration_month: courseMetaDetails?.duration || null,
      course_rating: ratingAverage || null,
      rating_count: ratingCount || null,
      category: (categoryIncludingParents && categoryIncludingParents[1]?.title) || null,
      sub_category: (categoryIncludingParents && categoryIncludingParents[2]?.title) || null,
    };

    dataLayer({
      ...DataLayerDegreePage,
      page_name: 'course_desc',
      event: 'course_desc',
    });
  };

  useEffect(() => {
    if (typeof window !== 'undefined' && !isLoading) {
      userDataLayerEvent();
    }
  }, [router.isReady, isLoggedIn]);

  useEffect(() => {
    DataLayerParam();
  }, []);

  return isLoading ? (
    <Loader />
  ) : (
    <main>
      <nav>
        <PremiumInstituteNavBar />
      </nav>
      {children}
      <footer className="pb-[60px] medium:pb-[72px] large:pb-[44px]">
        <ElevateYourCareerSection />
      </footer>
    </main>
  );
};

export default OnlineDegreePremiumLayout;
